/*
 * @Descripttion: 
 * @version: 
 * @Author: sueRimn
 * @Date: 2020-11-12 11:20:11
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-12-25 10:01:57
 */
import request from '@/util/request'
// import qs from 'qs'
// import store from '@/store'

// 获取访客量总数
export function GetVisitTotal() {
  return request({
    url: '/api/ShadowClient/Count',
    method: 'get',
    params: {
      lasttime: window.localStorage.getItem('visitcuntQueryTime')//上次查询时间 用于搜索新增的访客数量
    }
  })
}
// 是否是主持人
export function GetUserType(params) {
  return request({
    url: 'https://wanapi.yzf.com.cn/api/yingzi/xqc/GetUserType',
    method: 'get',
    params,
  })
}
// 主持人列表
export function GetUserList(params) {
  return request({
    url: 'https://wanapi.yzf.com.cn/api/yingzi/xqc/GetUserList',
    method: 'get',
    params,
  })
}
// 获取获客总数
export function GetClientTotal() {
  return request({
    url: '/api/Registration/GetProps',
    method: 'get',
    params: {
    }
  })
}
// 获取转发总数
export function GetForwardTotal() {
  return request({
    url: '/api/UserPage/Get',
    method: 'get',
    params: {
      type: 0, //转发
      page_size: 1,
      page: 1
    }
  })
}
// 获取收藏总数
export function GetCollectionTotal() {
  return request({
    url: '/api/UserPage/Get',
    method: 'get',
    params: {
      type: 1,//收藏
      page_size: 1,
      page: 1
    }
  })
}
// 获取转发列表
export function GetForwardList(params) {
  return request({
    url: '/api/UserPage/Get',
    method: 'get',
    params: {
      type: 0, //转发
      page_size: 10, //每页条数
      is_paging: true, //是否分页

      is_asc: params.is_asc, //正序
      order_property: params.order_property, //排序字段
      page: params.page, //页码
      objectType: params.objectType, //查询范围
    }
  })
}
// 获取收藏列表
export function GetCollectionList(params) {
  return request({
    url: '/api/UserPage/Get',
    method: 'get',
    params: {
      type: 1, //收藏
      page_size: 10, //每页条数
      is_paging: true, //是否分页

      is_asc: params.is_asc, //正序
      order_property: params.order_property, //排序字段
      page: params.page, //页码
      objectType: params.objectType, //查询范围
    }
  })
}